import { EEvidenceCp } from 'enums/isin/evidenceCp';

const evidenceCpSelect = [
    {
        value: EEvidenceCp.CDCP,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCP'
    },
    {
        value: EEvidenceCp.CNB,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CNB'
    },
    {
        value: EEvidenceCp.MF,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_MF'
    },
    {
        value: EEvidenceCp.JINY,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY_ALT'
    }
];
export const evidenceCpSelectZAKN = [
    {
        value: EEvidenceCp.CDCP,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCP'
    },
    {
        value: EEvidenceCp.CNB,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CNB'
    },
    {
        value: EEvidenceCp.MF,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_MF'
    },
    {
        value: EEvidenceCp.CDCPDLT,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCPDLT'
    },
    {
        value: EEvidenceCp.JINY,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY_ALT'
    }
];

export const evidenceCpSelectEdit = [
    {
        value: EEvidenceCp.CDCP,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCP'
    },
    {
        value: EEvidenceCp.CNB,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CNB'
    },
    {
        value: EEvidenceCp.MF,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_MF'
    },
    {
        value: EEvidenceCp.CDCPDLT,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCPDLT'
    },
    {
        value: EEvidenceCp.JINY,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY_ALT'
    }
];
export const evidenceCpSelectEditIsin = [
    {
        value: EEvidenceCp.CNB,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CNB'
    },
    {
        value: EEvidenceCp.MF,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_MF'
    },
    {
        value: EEvidenceCp.JINY,
        labelcz: 'ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY_ALT'
    }
];

export default evidenceCpSelect;
